import { IVehcileDefaultValues } from "interfaces/session/IVehicle";
import { ISetVehcileDefaultValues } from "../interfaces/garage.interface";

export function setVehicleDefaultValue(values: IVehcileDefaultValues): ISetVehcileDefaultValues {
  return {
    type: "SET_DEFAULT_MAKE_MODEL",
    data: values,
  };
}
